import { AttributeFilter } from 'app/shared/ui/models/attribute-filter';

export class TransporterMemberAttributeFilter implements AttributeFilter {
  attribute: string;
  label: string;
  operator: string;
  value?: string;
  tempValue?: string | undefined;
  secondValue?: any;

  constructor(attribute: string, label: string, operator: string, value?: string, secondValue?: any) {
    this.attribute = attribute;
    this.label = label;
    this.operator = operator;
    this.value = value;
    this.secondValue = secondValue;
  }

  updateValue(): any {
    const filters = Object.create({});
    this.value = this.tempValue;
    filters[this.attribute + '.' + this.operator] = this.value;
    return filters;
  }

  isChecked(): boolean {
    if (this.tempValue && this.operator) {
      return true;
    } else {
      return false;
    }
  }

  htmlButtonText(): string {
    let htmlContent = '<b>' + this.label + '</b> ';
    if (this.operator === 'equals') {
      htmlContent += 'est';
    } else {
      htmlContent += '';
    }
    htmlContent += ' <b>' + this.secondValue + '</b>';
    return htmlContent;
  }
}
